import { handleError } from "utils/errorHandler";

const API_BASE_URL =
  process.env.REACT_APP_CHATBOT_API ||
  "https://rexfordkodeportfolio-backend-latest-1.onrender.com";

export interface ChatMessage {
  message: string;
  sessionId?: string;
}

export interface ChatResponse {
  response: string;
  sessionId: string;
  source: "profile" | "llm";
  timestamp: number;
}

export interface ContactData {
  name: string;
  email: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
}

class ChatbotService {
  async sendMessage(
    message: string,
    sessionId?: string,
  ): Promise<ChatResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/chat/message`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message,
          sessionId,
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      handleError(error, {
        component: "ChatbotService",
        operation: "sendMessage",
        endpoint: "/api/chat/message",
      });
      throw error;
    }
  }

  async sendContactMessage(data: ContactData): Promise<ContactResponse> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/notification/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      handleError(error, {
        component: "ChatbotService",
        operation: "sendContactMessage",
        endpoint: "/api/notification/contact",
      });
      throw error;
    }
  }

  async checkHealth(): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/chat/health`);
      return response.ok;
    } catch (error) {
      handleError(error, {
        component: "ChatbotService",
        operation: "checkHealth",
        endpoint: "/api/chat/health",
        verbose: false,
      });
      return false;
    }
  }
}
const chatbotService = new ChatbotService();

export default chatbotService;
